import { Dispatch, SetStateAction, memo } from 'react';
import { Grid } from '@mantine/core';
import { type MRT_PaginationState } from 'mantine-react-table';
import { useTranslation } from 'react-i18next';
import Table from '../../../components/Table';
import { SuppliesReportTableInfoData } from '.';

export default memo(function TableView({
  tableInfoData = [],
  totalRowsCount = 0,
  pages = 0,
  isError = false,
  isLoading = false,
  pagination,
  setPagination
}: {
  tableInfoData: SuppliesReportTableInfoData[];
  totalRowsCount: any;
  pages: any;
  isError: boolean;
  isLoading: boolean;
  pagination: MRT_PaginationState;
  setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;
}) {
  const { t } = useTranslation(['FieldName']);
  const columns = [
    {
      accessorFn: (row) => row.name,
      header: t('ReportsPage:suppliesReport.headers.supply')
    },
    {
      accessorFn: (row) => `${row.totalAmount?.toFixed(3)} ${row.purchaseUnit?.toUpperCase()}`,
      header: t('ReportsPage:suppliesReport.headers.totalAmount')
    },
    {
      accessorFn: (row) => row.totalCost ? row.totalCost.toFixed(2) : '0.00',
      header: t('ReportsPage:suppliesReport.headers.totalCost')
    },
    {
      accessorFn: (row) => row.usageUnit,
      header: t('ReportsPage:suppliesReport.headers.usageUnit')
    },
    {
      accessorFn: (row) => row.records,
      header: t('ReportsPage:suppliesReport.headers.records')
    }
  ];

  return (
    <>
      <Grid gutter="md">
        <Grid.Col span={12}>
          <Table
            tableColumns={columns}
            pagination={pagination}
            setPagination={setPagination}
            tableData={tableInfoData}
            isError={isError}
            paginationIsLoading={isLoading}
            numPages={pages}
            totalRowsCount={totalRowsCount}
            overrideTableConfigs={{
              manualPagination: false
            }}
          />
        </Grid.Col>
      </Grid>
    </>
  );
});
